const headingFont = {
    fontFamily: 'var(--font-headings)',
    fontWeight: 700
};

export default {
    palette: {
        primary: {
            main: 'rgb(41 41 41)'
        },
        secondary: {
            main: 'rgb(220 59 63)'
        }
    },
    typography: {
        fontFamily: 'var(--font-primary)',
        h1: { ...headingFont },
        h2: { ...headingFont },
        h3: { ...headingFont },
        h4: { ...headingFont },
        h5: {
            ...headingFont,
            color: 'var(--dark-grey)'
        },
        h6: {
            ...headingFont
            // '&::after': {
            //     height: 4,
            //     width: 175,
            //     display: 'block',
            //     position: 'absolute',
            //     content: '""',
            //     background: 'red'
            // }
        }
    },
    overrides: {
        MuiButton: {
            root: {
                fontWeight: 'bold'
            },
            outlinedPrimary: {
                border: 'none',
                backgroundColor: 'var(--cream)',
                color: 'var(--grey)',
                fontWeight: '600',
                borderRadius: '0',
                boxShadow: 'inset 0 0 0 1px rgba(var(--black-rgb) / 10%)',
                '&:hover': {
                    border: 'none',
                    backgroundColor: 'var(--metal) !important',
                    color: 'var(--white)'
                }
            }
        },
        MuiPickersDay: {
            daySelected: {
                color: '#fff',
                backgroundColor: 'rgba(220 59 63 / 100%)'
            }
        },
        MuiPaper: {
            root: {
                // backgroundColor: 'var(--silver)',
                // boxShadow: 'none !important'
            }
        }
    }
};
